/**
 * Created by Jerry on 2017/10/17.
 */

//设置微信标题
export function setTitle(title){
    if (/ip(hone|od|ad)/i.test(navigator.userAgent)){
        document.title=title;
        var i=document.createElement('iframe');
        i.style.display='none';
        i.onload=function(){setTimeout(function(){i.remove();},9)};
        document.body.appendChild(i);
    } else  document.title=title;
}

//判断是否在小程序环境
export  function  isWebview(cb){
    if(window.__wxjs_environment)
     wx.miniProgram.getEnv((res)=>{
        if(res.miniprogram) cb(true)
        else cb(false)
    })
    else cb(false)
}



var Vue = require('d/vue'),vm=new Vue();

 let mixin={
    methods:{
        /*检测实际支付是否成功的查询接口*/
        checkPay(pay_order_sn,payment_platform){
            if(!payment_platform) payment_platform='WeixinJSAPI'
           return vm.$http.post('/api/pay_params/check_pay_status',{
               pay_order_sn,
               payment_platform
           }).then(res=>res.json())
        },
    }
}
export default mixin



// WEBPACK FOOTER //
// ./src/common/js/common.js